import React from 'react'
import './Placeholder.scss'

import Popup from '../../partials/Popup/Popup.js'

export default function Placeholder(props) {
    return (
        <div className="Placeholder">
           <Popup 
           data={
               {header:"Under Construction",
               body:(`<p>The segment "<b>${props.type}</b>" is currently unavailable. </p>`),
               button:"Next Segment"
               
           }} 
           scrim={true}
           onClose={props.onComplete}/>
        </div>
    )
}
